/**
 * 余额页深链：打开「订单记录」Tab 并自动打开发票管理弹窗。
 * 与 `components/balances/index.tsx` 中 `useSearchParams` 约定一致。
 */
export const BALANCES_ORDER_INVOICE_DEEP_LINK =
  '/balances?tab=order&openInvoice=1';
